/**
 * style
 */
import "./resources/sass/styles.scss";
/**
 * page
 */
import Landing from "./page/Landing";

function App() {
  return (
    <>
      <Landing />
    </>
  );
}

export default App;
